import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../auth.service';
import { SocialAuthService } from '../social-auth.service';
import { CurrentUser } from '../current-user';
import { ActivatedRoute, Router } from '@angular/router';
import { Settings } from '../../core/config/settings.service';
import { Toast } from '../../core/ui/toast.service';
import { Bootstrapper } from '../../core/bootstrapper.service';
import { RecaptchaService } from '../../core/services/recaptcha.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from '@common/core/ui/custom-menu/menu-item';
import { slugifyString } from '@common/core/utils/slugify-string';
import { BackendErrorResponse } from '@common/core/types/backend-error-response';
import { filter } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';




@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterComponent implements OnInit {
    passData = [];
    queryObj: any;

    jioemail: {
        email: ""
    };

    itemPriceId: any
    referId: any
    savedPlan: any;

    email$ = new BehaviorSubject<number>(null);

    public loading$ = new BehaviorSubject<boolean>(false);
    check = true;
    password1;
    password2;
    show1 = false;
    show2 = false;
    public registerPolicies: Partial<MenuItem>[] = [];
    public form = this.fb.group({
        first_name: [''],
        last_name: [''],
        email: [''],
        password: [''],
        password_confirmation: [''],
        purchase_code: [''],
        item_price_id: [''],
        refer_id: [''],
    });
    public errors$ = new BehaviorSubject<{
        first_name?: string,
        last_name?: string,
        email?: string,
        password?: string,
        general?: string,
        purchase_code?: string,
        item_price_id?: string,
        refer_id?: string,
    }>({});



    constructor(
        public auth: AuthService,
        public socialAuth: SocialAuthService,
        public settings: Settings,
        public route: ActivatedRoute,
        private activatedRoute: ActivatedRoute,
        private user: CurrentUser,
        private router: Router,
        private toast: Toast,
        private bootstrapper: Bootstrapper,
        private recaptcha: RecaptchaService,
        private fb: FormBuilder,
        private http: HttpClient

    ) {
        // this.activatedRoute.queryParams.subscribe(data => {
        //     this.email = data.email;
        //     // this.item_price_id = data.item_price_id;
        // })

    }

    ngOnInit() {
        // console.log("router", this.route.snapshot?.queryParams?.item_price_id)
        this.itemPriceId = this.route.snapshot?.queryParams?.item_price_id;
        this.referId = this.route.snapshot?.queryParams?.refer_id;

        this.password1 = 'password';
        this.password2 = 'password';
        this.registerPolicies = this.settings.getJson('register_policies', []);
        this.registerPolicies.forEach(policy => {
            policy.id = slugifyString(policy.label, '_');
            this.form.addControl(policy.id, new FormControl(false));
        });
        if (this.recaptcha.enabledFor('registration')) {
            this.recaptcha.load();
        }
        this.auth.forcedEmail$
            .pipe(filter(email => !!email))
            .subscribe(email => {
                this.form.get('email').setValue(email);
                this.form.get('email').disable();
            });
    }

    public async register() {
        this.loading$.next(true);
        // if (this.recaptcha.enabledFor('registration') && ! await this.recaptcha.verify('registration')) {
        //     this.loading$.next(false);
        //     return this.toast.open('Could not verify you are human.');

        // }

        // var body = "email" + "item_price_id";
        // this.http.post("https://aws.jio.sh/api/v1/chargebee/create-charge", body).subscribe((data) => { });
        console.log(this.itemPriceId)
        this.auth.register(this.form.getRawValue())
            .subscribe(response => {

                if (response.status === 'needs_email_verification') {

                    this.router.navigate(['/login']).then(() => {
                        this.loading$.next(false);
                        this.toast.open(response.message, {duration: 12000});
                    });
                }
                else {
                    this.bootstrapper.bootstrap(response.bootstrapData);
                    this.router.navigate([this.auth.getRedirectUri()]).then(() => {
                        this.loading$.next(false);
                        this.toast.open('Registered successfully.');
                    });
                }
            }, (errResponse: BackendErrorResponse) => {
                this.errors$.next(errResponse.errors);
                this.loading$.next(false);
            });
    }

    getRegister(credentials: any) {
        this.savedPlan = JSON.parse(localStorage.getItem('selectedPlan'));
        if (this.savedPlan) {
            console.log(this.savedPlan);
        }
        let baseUrl = "https://aws.jio.sh/api/v1/chargebee/create-charge/credentials.json"
        // console.log(credentials);
        const headers = new HttpHeaders({});
        this.http.post(baseUrl, credentials)
            .subscribe((res: any) => {
                console.log(res.status == 200);
                console.log("true");
                // this.passData = this.form.value;
                // var jio = { email: '', item_price_id: '' }
                // this.passData.push(jio)
                (err: any) => {
                    alert("There was a problem logging you out");
                };
            });
    }

    toggleshow1() {
        if (this.password1 === 'password') {
            this.password1 = 'text';
            this.show1 = true;
        } else {
            this.password1 = 'password';
            this.show1 = false;
        }
    }
    toggleshow2() {
        if (this.password2 === 'password') {
            this.password2 = 'text';
            this.show2 = true;
        } else {
            this.password2 = 'password';
            this.show2 = false;
        }
    }
}
